import type { Font } from '../types/font';

export const ptSerif: Font = {
  fontFamily: 'pt-serif-m4b547c4',
  displayName: 'PT Serif',
  sources: [
    {
      fontStyle: 'italic',
      fontWeight: 'normal',
      unicodeRange: 'cyrillicExt',
      src: 'pt-serif-v18-cyrillic-ext-400-italic.woff2',
      format: 'woff2',
    },
    {
      fontStyle: 'italic',
      fontWeight: 'normal',
      unicodeRange: 'cyrillic',
      src: 'pt-serif-v18-cyrillic-400-italic.woff2',
      format: 'woff2',
    },
    {
      fontStyle: 'italic',
      fontWeight: 'normal',
      unicodeRange: 'latinExt',
      src: 'pt-serif-v18-latin-ext-400-italic.woff2',
      format: 'woff2',
    },
    {
      fontStyle: 'italic',
      fontWeight: 'normal',
      unicodeRange: 'latin',
      src: 'pt-serif-v18-latin-400-italic.woff2',
      format: 'woff2',
    },
    {
      fontStyle: 'italic',
      fontWeight: 'bold',
      unicodeRange: 'cyrillicExt',
      src: 'pt-serif-v18-cyrillic-ext-700-italic.woff2',
      format: 'woff2',
    },
    {
      fontStyle: 'italic',
      fontWeight: 'bold',
      unicodeRange: 'cyrillic',
      src: 'pt-serif-v18-cyrillic-700-italic.woff2',
      format: 'woff2',
    },
    {
      fontStyle: 'italic',
      fontWeight: 'bold',
      unicodeRange: 'latinExt',
      src: 'pt-serif-v18-latin-ext-700-italic.woff2',
      format: 'woff2',
    },
    {
      fontStyle: 'italic',
      fontWeight: 'bold',
      unicodeRange: 'latin',
      src: 'pt-serif-v18-latin-700-italic.woff2',
      format: 'woff2',
    },
    {
      fontStyle: 'normal',
      fontWeight: 'normal',
      unicodeRange: 'cyrillicExt',
      src: 'pt-serif-v18-cyrillic-ext-400.woff2',
      format: 'woff2',
    },
    {
      fontStyle: 'normal',
      fontWeight: 'normal',
      unicodeRange: 'cyrillic',
      src: 'pt-serif-v18-cyrillic-400.woff2',
      format: 'woff2',
    },
    {
      fontStyle: 'normal',
      fontWeight: 'normal',
      unicodeRange: 'latinExt',
      src: 'pt-serif-v18-latin-ext-400.woff2',
      format: 'woff2',
    },
    {
      fontStyle: 'normal',
      fontWeight: 'normal',
      unicodeRange: 'latin',
      src: 'pt-serif-v18-latin-400.woff2',
      format: 'woff2',
    },
    {
      fontStyle: 'normal',
      fontWeight: 'bold',
      unicodeRange: 'cyrillicExt',
      src: 'pt-serif-v18-cyrillic-ext-700.woff2',
      format: 'woff2',
    },
    {
      fontStyle: 'normal',
      fontWeight: 'bold',
      unicodeRange: 'cyrillic',
      src: 'pt-serif-v18-cyrillic-700.woff2',
      format: 'woff2',
    },
    {
      fontStyle: 'normal',
      fontWeight: 'bold',
      unicodeRange: 'latinExt',
      src: 'pt-serif-v18-latin-ext-700.woff2',
      format: 'woff2',
    },
    {
      fontStyle: 'normal',
      fontWeight: 'bold',
      unicodeRange: 'latin',
      src: 'pt-serif-v18-latin-700.woff2',
      format: 'woff2',
    },
  ],
};
